export default __webpack_public_path__ + "static/media/bug-light.0495fb17.svg";